module.exports = __webpack_public_path__ + "static/media/calendar_black.16458795.svg";